// source from ==> https://github.com/awesomejerry/react-native-qrcode-svg

import React, { PureComponent } from 'react'
import { Image as RNImage, ImageURISource } from 'react-native'
import Svg, { Defs, G, Rect, Path, Image, ClipPath, Text } from 'react-native-svg'

import { COLORS } from 'x/config/styles'

import genMatrix from './genMatrix'

const DEFAULT_SIZE = 100
const DEFAULT_BG_COLOR = 'white'

type ECL = 'L' | 'M' | 'Q' | 'H'

export interface QRCodeProps {
  value?: string
  txtBottomQR?: string
  size?: number
  color?: string
  backgroundColor?: string
  logo?: ImageURISource
  logoSize?: number
  logoBackgroundColor?: string
  logoMargin?: number
  logoBorderRadius?: number
  // getRef?: (ref: any) => void

  innerRef?: React.RefObject<QRCode>

  ecl?: ECL
  isVisibleTextValue?: boolean
  textValueSize?: number
  customPadding?: number
}

/**
 * A simple component for displaying QR Code using svg
 */
export default class QRCode extends PureComponent<QRCodeProps> {
  static defaultProps: QRCodeProps = {
    value: 'This is a QR Code.',
    txtBottomQR: 'This is a Text.',
    size: DEFAULT_SIZE,
    color: 'black',
    backgroundColor: DEFAULT_BG_COLOR,
    logoSize: DEFAULT_SIZE * 0.2,
    logoBackgroundColor: DEFAULT_BG_COLOR,
    logoMargin: 2,
    logoBorderRadius: 0,
    ecl: 'H',
    isVisibleTextValue: false,
    textValueSize: 14,
    customPadding: 0,
  }

  private _matrix: any
  private _cellSize: number
  private _path: string

  constructor(props: QRCodeProps) {
    super(props)
    this._matrix = null
    this._cellSize = 0
    this._path = ''
    this.setMatrix(props)
  }

  componentWillUpdate(nextProps: QRCodeProps) {
    if (nextProps.value !== this.props.value || nextProps.size !== this.props.size) {
      this.setMatrix(nextProps)
    }
  }

  setMatrix(props: QRCodeProps) {
    const { value = '', size = DEFAULT_SIZE, ecl = 'H', customPadding = 0 } = props
    this._matrix = genMatrix(value, ecl)
    this._cellSize = (size - customPadding * 2) / this._matrix.length
    this._path = this.transformMatrixIntoPath()
  }

  transformMatrixIntoPath(): string {
    const matrix = this._matrix
    const cellSize = this._cellSize
    let d = ''
    matrix.forEach((row: any[], i: number) => {
      let needDraw = false
      row.forEach((column: any, j: number) => {
        if (column) {
          if (!needDraw) {
            d += `M${cellSize * j} ${cellSize / 2 + cellSize * i} `
            needDraw = true
          }
          if (needDraw && j === matrix.length - 1) {
            d += `L${cellSize * (j + 1)} ${cellSize / 2 + cellSize * i} `
          }
        } else if (needDraw) {
          d += `L${cellSize * j} ${cellSize / 2 + cellSize * i} `
          needDraw = false
        }
      })
    })
    return d
  }

  render() {
    const {
      // getRef,
      innerRef,
      size = DEFAULT_SIZE,
      color = 'black',
      backgroundColor = DEFAULT_BG_COLOR,
      logo,
      logoSize = DEFAULT_SIZE * 0.2,
      logoMargin = 2,
      logoBackgroundColor = DEFAULT_BG_COLOR,
      logoBorderRadius = 0,
      txtBottomQR = 'This is a Text.',
      isVisibleTextValue = false,
      customPadding = 0,
      textValueSize = 14,
    } = this.props

    const containerWidth = size
    let containerHeight = size
    if (isVisibleTextValue) {
      containerHeight += 18
    }

    const logoPosition = size / 2 - logoSize / 2 - logoMargin
    const logoWrapperSize = logoSize + logoMargin * 2
    const logoWrapperBorderRadius = logoBorderRadius + (logoBorderRadius && logoMargin)

    return (
      <Svg
        // ref={getRef}
        ref={innerRef}
        width={containerWidth}
        height={containerHeight}
      >
        <Defs>
          <ClipPath id='clip-wrapper'>
            <Rect width={logoWrapperSize} height={logoWrapperSize} rx={logoWrapperBorderRadius} ry={logoWrapperBorderRadius} />
          </ClipPath>
          <ClipPath id='clip-logo'>
            <Rect width={logoSize} height={logoSize} rx={logoBorderRadius} ry={logoBorderRadius} />
          </ClipPath>
        </Defs>
        <Rect width={containerWidth} height={containerHeight} fill={backgroundColor} />
        {/* This is QR Code writing */}
        <G x={customPadding} y={customPadding}>
          <Path d={this._path} stroke={color} strokeWidth={this._cellSize} />
        </G>
        {logo && (
          <G x={logoPosition} y={logoPosition}>
            <Rect width={logoWrapperSize} height={logoWrapperSize} fill={logoBackgroundColor} clipPath='url(#clip-wrapper)' />
            <G x={logoMargin} y={logoMargin}>
              <Image width={logoSize} height={logoSize} preserveAspectRatio='xMidYMid slice' href={logo} clipPath='url(#clip-logo)' />
            </G>
          </G>
        )}
        {isVisibleTextValue ? (
          <G x={size / 2} y={size + textValueSize / 2}>
            <Text fill={COLORS.APP_MAIN} stroke={COLORS.APP_MAIN} fontSize={textValueSize} fontWeight='bold' textAnchor='middle'>
              {txtBottomQR}
            </Text>
          </G>
        ) : null}
        <G x={0} y={size + textValueSize}>
          <Text fill={COLORS.TEXT_INACTIVE} fontSize={6} fontWeight='100' textAnchor='start'>
            {'v2'}
          </Text>
        </G>
      </Svg>
    )
  }
}
